<template>
  <div>
    <ViewLoader v-if="loading"/>
    <template v-else>
      <template v-if="medias.length > 0">
        <div class="row collage-photo">
          <div class="col-6 col-sm-6 col-lg-4 col-xl-3" v-for="(media, index) in medias" :key="media.id">
            <Media :favorite-enabled="false" :gallery="{}" :media="media" :index="index" @select="showGallery(index)"/>
          </div>
        </div>
      </template>

      <div class="d-flex align-items-center">
        <ModalMedia ref="modalPhotoGalleryAllPhotos"
                            :favorite-enabled="false"
                            :medias="medias"
                            :total-medias="totalMedias"
                            :page="page"
                            @nextPage="$emit('nextPage', $event)"
                            :modal-id="'modalPhotoGalleryAllPhotos'"/>
      </div>
    </template>
  </div>
</template>


<script>
import ModalMedia from '@/domain/galleries/modals/ModaMedia.vue'
import ViewLoader from "@/components/ViewLoader.vue";
import Media from "@/domain/galleries/medias/Media.vue";

export default {
  name: 'AllPhotosList',

  components: {
    Media,
    ViewLoader,
    ModalMedia
  },

  props: {
    checkin: {
      type: Object,
      required: true
    },
    medias: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: false,
    },
    totalMedias: {
      type: Number,
      required: true
    },
    page: {
      type: Number,
      required: true,
      default: 1
    }
  },

  methods: {
    showGallery(index) {
      this.$refs.modalPhotoGalleryAllPhotos.show(index)
    },
  }
}
</script>
